import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router";
import Api from "../../Api/Api";
import { API as api, username } from "../../API";
import axios from "axios";
import { isAutheticated } from "../auth/authhelper";
import { FaCartPlus } from "react-icons/fa";
import ToastProduct from "../ToastProduct";
import React from "react";

const PlayMovie = ({ getCart }) => {
  const [currentProduct, setCurrentProduct] = useState(false);
  const [studioData, setStudioData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [toast, setToast] = useState(false);
  const [adVideo, setAdVideo] = useState(false);
  let { time, videoid, showid } = useParams();
  const [resumeTime, setResumeTime] = useState(time);
  const { token } = isAutheticated();

  const pouseHander = async () => {
    const video = document.getElementById("player");
    time = video.currentTime;
    await Api.postMovieInfo({
      videoid: videoid,
      timeid: video.currentTime,
    });
  };
  window.onunload = function (e) {
    e.preventDefault();
    pouseHander();
  };
  // const playHandler = () => {
  //   const video = document.getElementById("player");
  //   video.currentTime = time
  // }

  var intervalId = window.setInterval(function () {
    if (!adVideo) {
      const video = document.getElementById("player");
      if (video) {
        const isVideoPlaying =
          video.currentTime > 0 &&
          !video.paused &&
          !video.ended &&
          video.readyState > 2;
        if (isVideoPlaying) {
          for (let i = 0; i < studioData?.items?.length; i++) {
            // console.log("time", studioData?.items[i].current_time, ~~video.currentTime);
            // console.log("time", studioData?.current_time[i] == ~~video.currentTime);
            if (studioData?.items[i].current_time == ~~video.currentTime) {
              console.log("id", studioData?.items[i].videoId, videoid);
              if (studioData?.items[i].videoId === videoid) {
                console.log("setProduct");
                if (studioData?.items[i].CTA === "Insert Ad Video") {
                  setAdVideo(studioData.items[i]);
                  setResumeTime(Number(studioData.items[i].current_time) + 1);
                } else {
                  setCurrentProduct({
                    duration: studioData?.items[i].duration,
                    url: studioData?.items[i].url,
                    product: studioData?.items[i].product,
                    CTA: studioData?.items[i].CTA,
                    qr_code: studioData?.items[i].qr_code,
                  });
                  setToast(true);
                }
              }
            }
          }
        }
      }
    }
  }, 1000);

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  });

  const handleClose = () => {
    setToast(false);
    // setCurrentProduct(false)
  };

  useEffect(() => {
    const getStudio = async (videoId) => {
      try {
        const response = await axios({
          url: `${api}/api/studio/${videoId}/get_studio`,
          headers: {
            "Access-Control-Allow-Origin": "*",
            // Authorization: `Bearer ${localStorage.getItem("id_token")}`,
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(response.data.data);
        setStudioData(response.data.data);
      } catch (err) {
        console.log(err);
      }
      // setStudioData(res?.data)
    };
    getStudio(videoid);
  }, [videoid, token]);

  function pauseVid() {
    const video = document.getElementById("player");
    video.pause();
    getCart();
  }

  const addToCart = async () => {
    setLoading(true);
    const req_quantity = 1;
    const productId = currentProduct.product._id;
    try {
      const data = await Api.addToCart(username, productId, req_quantity);
      setLoading(false);
      console.log(data);
    } catch (e) {
      setLoading(false);
    }
    getCart();
    let closeCanvas = document.getElementById("shopOnDeviceClose");
    closeCanvas.click();
    setShowCart(true);
    let timeout = setTimeout(function () {
      setShowCart(false);
    }, 15000);
  };

  const AdVideoEnd = () => {
    setAdVideo(false);
  };
  const history = useHistory();
  const handleVideoEnd = () => {
    // Redirect to the desired page after video ends
    history.push(`/view/${videoid}`);
  };

  return (
    <>
      <div>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          {adVideo ? (
            <video
              onEnded={() => AdVideoEnd()}
              id="AdPlayer"
              // onPause={pouseHander}
              // src={`https://sgp1.digitaloceanspaces.com/storage.tellytell.com/video-${showid}`}
              src={adVideo.url}
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
              }}
              // controls
              autoPlay={true}
            ></video>
          ) : (
            <video
              id="player"
              // onPlay={playHandler}
              onPause={pouseHander}
              onEnded={handleVideoEnd}
              src={`https://res.cloudinary.com/duenuiiav/video/upload/v1649441298/videos/${showid}#t=${resumeTime}`}
              // src={`https://sgp1.digitaloceanspaces.com/storage.tellytell.com/video-${showid}`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                position: "absolute",
                left: "0",
                top: "0",
                minWidth: "100%",
              }}
              controls
              autoPlay={true}
            ></video>
          )}
          {true && (
            <div
              className="text-light position-absolute"
              style={{
                top: "1rem",
                backgroundColor: "",
                right: "2rem",
                zIndex: "2",
              }}
            >
              <button
                onClick={pauseVid}
                id="cartButton"
                data-bs-toggle="offcanvas"
                data-bs-target="#cart"
                aria-controls="cart"
                className="btn py-0 px-2 text-white"
              >
                <small>
                  <FaCartPlus size="2rem" />
                </small>
              </button>
            </div>
          )}
          <div
            className="text-light position-absolute"
            style={{ bottom: "4rem", right: "2rem", zIndex: "2" }}
          >
            {toast && (
              <ToastProduct
                product={currentProduct}
                handleClose={handleClose}
                pauseVid={pauseVid}
              />
            )}
          </div>
        </div>

        <div
          className="offcanvas offcanvas-end"
          style={{ backgroundColor: "black" }}
          tabindex="-1"
          id="shopOnDevice"
          aria-labelledby="shopOnDevice"
        >
          <div className="offcanvas-header">
            {/* <h5 id="offcanvasRightLabel"></h5> */}
            <button
              type="button"
              className="btn-close text-reset"
              style={{ backgroundColor: "white" }}
              id="shopOnDeviceClose"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="text-center">
              <img
                width="90%"
                style={{ height: "40vh" }}
                src={currentProduct?.product?.image}
                alt="product"
              />
            </div>
            <div className="text-white mx-4 mt-3">
              <h2>{currentProduct?.product?.title}</h2>
              <p>{currentProduct?.description}</p>
              <div>
                <h4>₹ {currentProduct?.product?.sale_price}</h4>
              </div>
              <button
                disabled={loading}
                className="w-100 mt-2 btn btn-outline-light btn-lg"
                onClick={addToCart}
              >
                <FaCartPlus />
                &nbsp;&nbsp;<b>Add To Cart</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PlayMovie;
